import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LocalStorageService {
  private allDocsSubject = new BehaviorSubject<any[]>(this.getAllDocs());

  constructor() {
    window.addEventListener('storage', this.handleStorageChange.bind(this));
  }

  private handleStorageChange(event: StorageEvent) {
    if (event.key === 'allDocs') {
      this.allDocsSubject.next(this.getAllDocs());
    }
  }

  private getAllDocs(): any[] {
    return JSON.parse(localStorage.getItem('allDocs')) || [];
  }

  get allDocs$() {
    return this.allDocsSubject.asObservable();
  }

  setAllDocs(allDocs: any[]) {
    localStorage.setItem('allDocs', JSON.stringify(allDocs));
    this.allDocsSubject.next(allDocs);
  }
}